import { FC } from 'react';

import { useI18nContext } from '../../hooks/contexts/i18n.context';
import * as Styles from './exclusive-credit-card-brand.styles';

type ExclusiveCreditCardBrandProps = {
  logo: string;
  name: string;
}

const ExclusiveCreditCardBrand: FC<ExclusiveCreditCardBrandProps> = ({ logo, name }) => {
  const { translate } = useI18nContext();

  return (
    <Styles.Wrapper>
      <img src={logo} alt={name} />
      <span
        dangerouslySetInnerHTML={{ __html : translate(['EXCLUSIVE_CARD'], { name }) }}
      />
    </Styles.Wrapper>
  );
};

export default ExclusiveCreditCardBrand;
